import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { Autocomplete, TextField } from "@mui/material";
import useUser from "../../hooks/entities/user";
import { formatPatientNameWithEmail } from "../../utils/questionnaire";
import styles from "./SelectPatient.module.css";

const SelectPatient = ({ handleSelect, translate, defaultValue }) => {
  const [value, setValue] = useState(null);
  // Load the full patient list (page:null still sent a page param and paginated).
  const hookUser = useUser({
    userType: "pacient",
    page: 0,
    rowsByPage: 10000,
  });

  useEffect(() => {
    hookUser.actions.listUsers();
  }, []);

  const userOptions = useMemo(() => {
    const options = hookUser.list.map((user) => {
      const name = `${user.first_name} ${user.last_name || ""}`.trim();
      return {
        value: user.id,
        name,
        label: formatPatientNameWithEmail(name, user.email),
        email: user.email,
      };
    });
    return _.sortBy(options, ["label"]);
  }, [hookUser.list]);

  useEffect(() => {
    if (!defaultValue) return;
    const initialOption = userOptions.find((option) => option.value === defaultValue);
    if (initialOption && (!value || value.value !== initialOption.value)) {
      setValue(initialOption);
    }
  }, [defaultValue, userOptions]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    handleSelect(newValue ? newValue.value : "");
  };

  return (
    <Autocomplete
      data-testid="select-patient"
      options={userOptions}
      getOptionLabel={(option) => (option ? option.label : "")}
      value={value}
      onChange={handleChange}
      isOptionEqualToValue={(option, value) =>
        (option && option.value) === (value && value.value)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          className={styles.input}
          placeholder={translate("search_patient")}
          variant="outlined"
          fullWidth
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.value} className={styles.list}>
          <div className={styles.option}>
            <span data-testid={`select-patient-name-${option.name}`}>
              {option.name}
              {option.email ? (
                <>
                  {" "}
                  (
                  <span data-testid={`select-patient-email-${option.email}`}>
                    {option.email}
                  </span>
                  )
                </>
              ) : null}
            </span>
          </div>
        </li>
      )}
    />
  );
};

export default SelectPatient;
